import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export function LanguageSwitcher({ current, available }) {
    if (!available || available.length <= 1)
        return null;
    return (_jsx("div", { className: "career-language-switcher", children: available.map(lang => (_jsx("a", { href: `?lang=${lang.code}`, className: `px-2 ${lang.code === current ? 'font-bold underline' : ''}`, children: lang.code.toUpperCase() }, lang.code))) }));
}
